if (window.location.href.includes('fichatecnica-pedido')) {
  function goToFichaTecnica() {
    const id = document.getElementById('orderIdFichaTecnica').value.trim();
    if (id) {
      window.location.href = window.location.pathname + '?order_id=' + encodeURIComponent(id);
    }
  }

  document.addEventListener("DOMContentLoaded", async () => {
    const popup = document.getElementById("popup");
    const pedidoBox = document.getElementById("pedidoBox");

    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("order_id");
    if (!orderId) return;

    popup.style.display = "none";
    pedidoBox.style.display = "block";

    try {
      const res = await fetch(`https://ororosa.api.somarimapps.com/webhook/ficha-tecnica?order_id=${orderId}`);
      const data = await res.json();
      const pedido = Array.isArray(data) ? data[0] : data;

      if (!pedido || !pedido.lineItems || !Array.isArray(pedido.lineItems.edges)) {
        throw new Error("Pedido vacío o sin productos");
      }

      const items = pedido.lineItems.edges.map(e => e.node);
      if (items.length === 0) throw new Error("Pedido sin productos");

      pedidoBox.innerHTML = "";

      const header = document.createElement("h3");
      header.style.textAlign = "center";
      header.style.fontWeight = "bold";
      header.innerText = `Ficha técnica de pedido #${pedido.name || orderId}`;
      pedidoBox.appendChild(header);

      function parseArraySafe(raw) {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          return typeof raw === 'string' ? raw.split(',').map(e => e.trim()) : [];
        }
      }

      items.forEach((item) => {
        const variant = item.variant || {};
        const product = variant.product || {};
        const productImages = product.images?.edges || [];
        const imgSrcList = productImages.map(edge => edge?.node?.originalSrc).filter(Boolean);

        const rawMetafields = product.metafields?.edges || [];
        const metaSource = {};

        rawMetafields.forEach(el => {
          const key = el.node.key.toUpperCase()
            .replace("FICHA_TECNICA_", "")
            .replace("FT_", "")
            .replace(/_/g, "-");
          metaSource[key] = el.node.value;
        });

        const qtyComplementos = parseArraySafe(metaSource["QTY-COMPLEMENTOS"]);
        const idsComplementos = parseArraySafe(metaSource["IDS-COMPLEMENTOS"]);
        const qtyApliques = parseArraySafe(metaSource["QTY-APLIQUES"]);
        const idsApliques = parseArraySafe(metaSource["IDS-APLIQUES"]);

        // ✅ Tabla 1: Imágenes
        const tableImages = document.createElement("table");
        const rowImage = document.createElement("tr");
        const cellImage = document.createElement("td");
        cellImage.className = "imagenesPedido";
        cellImage.colSpan = 1;
        cellImage.innerHTML = imgSrcList.map(src => `<img src="${src}" />`).join('');
        rowImage.appendChild(cellImage);
        tableImages.appendChild(rowImage);
        pedidoBox.appendChild(tableImages);

        // ✅ Tabla 2: NOMBRE, COMPLEMENTOS, APLIQUES
        const table3cols = document.createElement("table");

        const rowName = document.createElement("tr");
        rowName.innerHTML = `
          <th>NOMBRE</th>
          <td>${item.title}</td>
          <td>${item.quantity}</td>
        `;
        table3cols.appendChild(rowName);

        if (idsComplementos.length || qtyComplementos.length) {
          const rowComp = document.createElement("tr");
          rowComp.innerHTML = `
            <th>COMPLEMENTOS</th>
            <td>${idsComplementos.map(e => e || "").join("<br>")}</td>
            <td>${qtyComplementos.map(e => e || "").join("<br>")}</td>
          `;
          table3cols.appendChild(rowComp);
        }

        if (idsApliques.length || qtyApliques.length) {
          const rowApliques = document.createElement("tr");
          rowApliques.innerHTML = `
            <th>APLIQUES</th>
            <td>${idsApliques.map(e => e || "").join("<br>")}</td>
            <td>${qtyApliques.map(e => e || "").join("<br>")}</td>
          `;
          table3cols.appendChild(rowApliques);
        }

        pedidoBox.appendChild(table3cols);

        // ✅ Tabla 3: Resto de campos a 4 columnas (2 pares por fila)
        const table4cols = document.createElement("table");

        const remainingFields = {
          "SKU": variant.sku || "",
          "VARIACIÓN": variant.title || "",
          "COMPOSICION": metaSource["COMPOSICION"] || "",
          "CAMISA": metaSource["CAMISA"] || "",
          "OBSERVACION": metaSource["OBSERVACION"] || "",
          "PRESION": metaSource["PRESION"] || "",
          "TIEMPO": metaSource["TIEMPO"] || "",
          "TEMPERATURA": metaSource["TEMPERATURA"] || "",
          "COSTO-FABRICACION": metaSource["COSTO-FABRICACION"] || "",
          "LINEA": metaSource["LINEA"] || "",
          "TIPOLOGIA": metaSource["TIPOLOGIA"] || ""
        };

        const keys = Object.keys(remainingFields);
        for (let i = 0; i < keys.length; i += 2) {
          const row = document.createElement("tr");

          const key1 = keys[i];
          const val1 = remainingFields[key1];

          const key2 = keys[i + 1];
          const val2 = key2 ? remainingFields[key2] : "";

          row.innerHTML = `
            <th>${key1}</th><td>${val1}</td>
            ${key2 ? `<th>${key2}</th><td>${val2}</td>` : `<td colspan="2"></td>`}
          `;

          table4cols.appendChild(row);
        }

        pedidoBox.appendChild(table4cols);
      });

    } catch (err) {
      console.error("❌ Error al cargar la ficha técnica:", err);
      pedidoBox.innerHTML = `
        <div style="background: #ffe6e6; color: #a00; padding: 20px; border-radius: 5px; font-weight: bold;">
          ❌ Error al cargar la ficha técnica: ${err.message}
        </div>`;
    }
  });
}